import { AxiosRequestConfig } from "axios";

export const postSignUpAppleConfig: AxiosRequestConfig = {
  method: "post",
  url: "/user",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
